export default __webpack_public_path__ + "static/media/5.22d08c6e.png";